import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconCrossLarge = createSVG({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M4.477 4.477a.668.668 0 0 1 .515-.235c.219 0 .399.078.54.235L12 10.945l6.469-6.468a.667.667 0 0 1 .515-.235c.22 0 .399.078.54.235.156.14.234.32.234.539a.667.667 0 0 1-.235.515L13.055 12l6.468 6.469c.157.14.235.32.235.539a.667.667 0 0 1-.235.515.693.693 0 0 1-.539.235.667.667 0 0 1-.515-.235L12 13.055l-6.469 6.468a.693.693 0 0 1-.539.235.667.667 0 0 1-.515-.235.668.668 0 0 1-.235-.515c0-.219.078-.399.235-.54L10.945 12 4.477 5.531a.668.668 0 0 1-.235-.515c0-.22.078-.399.235-.54z" }),
});

export { IconCrossLarge };
